import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import i18n from '@/libs/i18n'

export function getFlatpickrLocale() {
  if (i18n.locale === 'pt') return Portuguese
  if (i18n.locale === 'es') return Spanish
  return undefined
}
